<template>
  <div class="login" v-if="showMemeberList">
    <account-select
      :default-type="1"
      :items="items"
      :typeItems="typeItems"
      :loading="loading"
      @next="next"
    />
  </div>
</template>

<script>
// import {RSADncrypt,decryptByDES } from "../../../../utils";
import { getqueryCustomerKey } from "../../utils";
import { Message } from "element-ui";
export default {
  name: "login",
  data() {
    return {
      showMemeberList: false,
      loading: false,
      items: [
        { userId: 835, userName: "mltest001" },
        { userId: 13236, userName: "mltest002" },
        { userId: 13237, userName: "mltest003" },
        { userId: 13238, userName: "mltest004" },
        { userId: 13239, userName: "mltest005" },
        { userId: 13240, userName: "mltest006" },
        { userId: 13241, userName: "mltest007" },
        { userId: 13242, userName: "mltest008" },
        { userId: 13243, userName: "mltest009" },
        { userId: 13244, userName: "mltest010" },
        { userId: 13245, userName: "mltest011" },
        { userId: 13246, userName: "mltest012" },
        { userId: 13247, userName: "mltest013" },
        { userId: 13248, userName: "mltest014" },
        { userId: 13249, userName: "mltest015" },
        { userId: 13250, userName: "mltest016" },
        { userId: 13251, userName: "mltest017" },
        { userId: 13252, userName: "mltest018" },
        { userId: 13253, userName: "mltest019" },
        { userId: 13254, userName: "mltest020" }
      ],
      typeItems: [
        {
          label: "会员",
          value: 1
        },
        {
          label: "游客",
          value: 2
        }
      ]
    };
  },
  methods: {
    next() {
      Message.warning("本地測試清單尚未串接，請帶 configKey 進入");
    }
  },
  async created() {
    const hasConfigKey = /[?&]configKey=/.test(window.location.search);
    if (window.location.href.match(/localhost/) && !hasConfigKey) {
      this.showMemeberList = true;
      return;
    }
    await getqueryCustomerKey(this.$router);
    // getParams(params => {
    //   this.next(params);
    // });
  }
};
</script>

<style scoped lang="less"></style>
